import styled from 'styled-components';

export const PageTitle = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: ${({ theme }) => theme.typography.heading.h1.fontSize};
  font-weight: ${({ theme }) => theme.typography.heading.h1.fontWeight};
  line-height: ${({ theme }) => theme.typography.heading.h1.lineHeight};
  letter-spacing: ${({ theme }) => theme.typography.heading.h1.letterSpacing};
`;

export const LoadingText = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.body.medium.fontSize};
  margin: ${({ theme }) => theme.spacing[4]} 0;
`;

export const NoFilesText = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.body.medium.fontSize};
  margin: ${({ theme }) => theme.spacing[4]} 0;
`;

export const FileListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[3]};
  margin-bottom: ${({ theme }) => theme.spacing[6]};
`;

export const FileItemContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[2.5]};
`;

export const FileButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 700px;
  padding: ${({ theme }) => theme.spacing[3]} ${({ theme }) => theme.spacing[4]};
  border: 1px solid ${({ theme }) => theme.colors.primary.main};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background-color: transparent;
  color: ${({ theme }) => theme.colors.primary.main};
  font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
  font-size: ${({ theme }) => theme.typography.button.fontSize};
  font-weight: ${({ theme }) => theme.typography.button.fontWeight};
  text-transform: none;
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.duration.fast}
    ${({ theme }) => theme.transitions.easing.inOut};

  &:hover {
    background-color: ${({ theme }) => theme.colors.action.hover};
    border-color: ${({ theme }) => theme.colors.primary.dark};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary.main};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary.main}20;
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.action.selected};
  }
`;

export const FileCheckbox = styled.input.attrs({ type: 'checkbox' })`
  margin-right: ${({ theme }) => theme.spacing[2]};
  width: ${({ theme }) => theme.spacing[4]};
  height: ${({ theme }) => theme.spacing[4]};
  cursor: pointer;
  accent-color: ${({ theme }) => theme.colors.primary.main};

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary.main};
    outline-offset: 2px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: ${({ theme }) => theme.spacing[4]};
`;

export const ActionButton = styled.button`
  padding: ${({ theme }) => theme.spacing[2.5]}
    ${({ theme }) => theme.spacing[5]};
  background-color: ${({ theme }) => theme.colors.primary.main};
  color: ${({ theme }) => theme.colors.primary.contrastText};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
  font-size: ${({ theme }) => theme.typography.button.fontSize};
  font-weight: ${({ theme }) => theme.typography.button.fontWeight};
  text-transform: none;
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.duration.fast}
    ${({ theme }) => theme.transitions.easing.inOut};
  box-shadow: ${({ theme }) => theme.shadows.sm};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary.dark};
    box-shadow: ${({ theme }) => theme.shadows.md};
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    box-shadow:
      0 0 0 3px ${({ theme }) => theme.colors.primary.main}40,
      ${({ theme }) => theme.shadows.md};
  }

  &:active {
    transform: translateY(0);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.action.disabledBackground};
    color: ${({ theme }) => theme.colors.action.disabled};
    cursor: not-allowed;
    transform: none;
    box-shadow: none;

    &:hover {
      background-color: ${({ theme }) =>
        theme.colors.action.disabledBackground};
      box-shadow: none;
      transform: none;
    }
  }
`;
